(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cinematic-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const mobile = window.matchMedia('(max-width: 989px)');
    let width;
    const measure = () => {
      // Scrollbar removal during a modal lock is not a new viewport width.
      const nextWidth = window.innerWidth;
      if (width === nextWidth) return;
      width = nextWidth;
      document.querySelectorAll('[data-peak-stable-hero]').forEach((hero) => {
        hero.style.removeProperty('--peak-hero-height');
        if (!mobile.matches) return;
        // Some WKWebView shells resize even svh as their browser chrome moves.
        // Sample the CSS small viewport once per layout width, never per height.
        hero.style.setProperty('--peak-hero-height', getComputedStyle(hero).minHeight);
      });
    };
    measure();
    window.addEventListener('resize', measure, { passive: true });
    document.addEventListener('shopify:section:load', () => { width = undefined; measure(); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    isMobileSheetOpen() {
      return window.matchMedia('(max-width: 989px)').matches &&
        this.header.classList.contains('menu-open');
    }

    onScroll() {
      // Safari rubber-band offsets are not document scroll or scroll direction.
      const scrollTop = Math.max(0, window.scrollY ?? document.documentElement.scrollTop);

      // Menu, Search and Cart all own menu-open. Viewport/keyboard scroll is
      // not a dismissal or a reason to change the sheet's header geometry.
      if (this.isMobileSheetOpen()) {
        this.currentScrollTop = scrollTop;
        return;
      }

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.isMobileSheetOpen()) return;

      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.isMobileSheetOpen()) return;
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.isMobileSheetOpen()) return;
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      /*
        Never let Dawn's sticky-header lifecycle close an active mobile
        sheet. Sheets close only through their own X/drag/Escape/
        navigation lifecycle.
      */
      if (this.isMobileSheetOpen()) {
        return;
      }

      /*
        Peak search replaced Dawn's details-modal. Support both paths safely
        so scroll/hide behavior can never throw on a missing modal.
      */
      this.searchPanel =
        this.searchPanel ||
        this.header.querySelector('peak-search-panel');

      if (this.searchPanel && this.searchPanel.opened) {
        this.searchPanel.close({ restoreFocus: false });
        return;
      }

      this.searchModal =
        this.searchModal ||
        this.header.querySelector('details-modal');

      if (this.searchModal && typeof this.searchModal.close === 'function') {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  /* =========================================================
     PEAK — SEAMLESS DESKTOP DROPDOWN GLASS GEOMETRY

     JS does NOT render or blur anything.
     It only measures the open Dawn dropdown and exposes its exact
     geometry to the one continuous CSS glass surface.
     ========================================================= */

  class PeakDropdownGlassGeometry {
    constructor() {
      this.section = document.querySelector('.section-header');

      if (!this.section) return;

      this.media = window.matchMedia('(min-width: 990px)');
      this.raf = null;

      this.scheduleUpdate = this.scheduleUpdate.bind(this);
      this.update = this.update.bind(this);

      this.observer = new MutationObserver(
        this.scheduleUpdate
      );

      this.observer.observe(this.section, {
        attributes: true,
        attributeFilter: ['open', 'class'],
        subtree: true
      });

      window.addEventListener(
        'scroll',
        this.scheduleUpdate,
        { passive: true }
      );

      window.addEventListener(
        'resize',
        this.scheduleUpdate
      );

      this.update();
    }


    getOpenDropdown() {
      if (!this.media.matches) return null;

      const details = Array.from(
        this.section.querySelectorAll(
          '.header__inline-menu details[open]'
        )
      );

      for (const disclosure of details) {
        const dropdown = disclosure.querySelector(
          ':scope > .header__submenu.list-menu--disclosure'
        );

        if (!dropdown) continue;

        const rect = dropdown.getBoundingClientRect();

        if (rect.width > 0 && rect.height > 0) {
          return dropdown;
        }
      }

      return null;
    }


    clear() {
      this.section.classList.remove(
        'peak-dropdown-glass-open'
      );

      [
        '--peak-header-glass-height',
        '--peak-dropdown-left',
        '--peak-dropdown-top',
        '--peak-dropdown-width',
        '--peak-dropdown-height'
      ].forEach((property) => {
        this.section.style.removeProperty(property);
      });
    }


    update() {
      this.raf = null;

      const dropdown = this.getOpenDropdown();

      const active =
        this.media.matches &&
        this.section.classList.contains(
          'peak-dropdown-glass'
        ) &&
        dropdown;

      if (!active) {
        this.clear();
        return;
      }

      const sectionRect =
        this.section.getBoundingClientRect();

      const dropdownRect =
        dropdown.getBoundingClientRect();

      const headerHeight =
        sectionRect.height;

      const left =
        dropdownRect.left - sectionRect.left;

      const top =
        dropdownRect.top - sectionRect.top;

      this.section.style.setProperty(
        '--peak-header-glass-height',
        `${headerHeight.toFixed(2)}px`
      );

      this.section.style.setProperty(
        '--peak-dropdown-left',
        `${left.toFixed(2)}px`
      );

      this.section.style.setProperty(
        '--peak-dropdown-top',
        `${top.toFixed(2)}px`
      );

      this.section.style.setProperty(
        '--peak-dropdown-width',
        `${dropdownRect.width.toFixed(2)}px`
      );

      this.section.style.setProperty(
        '--peak-dropdown-height',
        `${dropdownRect.height.toFixed(2)}px`
      );

      this.section.classList.add(
        'peak-dropdown-glass-open'
      );
    }


    scheduleUpdate() {
      if (this.raf) return;

      this.raf = requestAnimationFrame(
        this.update
      );
    }
  }


  document.addEventListener('DOMContentLoaded', () => {
    new PeakDropdownGlassGeometry();
  });


  /* =========================================================
     PEAK — ADAPTIVE HEADER ICONS

     Desktop keeps the adaptive body-level utility icons. Mobile paints
     the native controls in the header so glass, logo and icons move together.
     ========================================================= */

  class PeakHeaderAdaptiveIcons {
    constructor() {
      this.section = document.querySelector('.section-header');

      if (!this.section) return;

      this.utilityOriginal = this.section.querySelector('.header__icons');
      this.homepageOverlay = Boolean(
        document.querySelector('.cinematic-hero')
      );

      this.utilityClone = null;

      this.buildUtilityClone();
      this.update();

      /* Dawn scroll-state changes. */
      this.sectionObserver = new MutationObserver(() => {
        this.update();
        this.position();
      });

      this.sectionObserver.observe(this.section, {
        attributes: true,
        attributeFilter: ['class'],
        subtree: false
      });

      window.addEventListener(
        'scroll',
        () => this.position(),
        { passive: true }
      );

      window.addEventListener(
        'resize',
        () => {
          this.buildUtilityClone();
          this.update();
        }
      );

      /* Search owns one state regardless of normal/scrolled header paint. */
      document.addEventListener('peak:search-state', () => {
        this.buildUtilityClone();
        this.update();
        this.position();
      });
    }


    removeIds(node) {
      if (node.id) {
        node.removeAttribute('id');
      }

      node.querySelectorAll('[id]').forEach((child) => {
        child.removeAttribute('id');
      });
    }


    buildUtilityClone() {
      if (this.utilityClone) {
        this.utilityClone.remove();
        this.utilityClone = null;
      }

      this.utilityOriginal = this.section.querySelector('.header__icons');

      // Mobile icons share the header's compositing/scrolling layer. Body-fixed
      // copies can drift from it during Safari's asynchronous rubber-band bounce.
      if (!this.utilityOriginal || window.matchMedia('(max-width: 989px)').matches) return;

      const clone = this.utilityOriginal.cloneNode(true);

      /*
        The inverse clone is visual-only. Never duplicate the live search
        dialog/predictive-search tree into body.
      */
      clone.querySelectorAll('[data-peak-search-layer]').forEach((layer) => {
        layer.remove();
      });

      this.removeIds(clone);

      clone.classList.add('peak-header-inverse-clone');
      clone.setAttribute('aria-hidden', 'true');

      clone.querySelectorAll('a, button, summary, input').forEach((element) => {
        element.setAttribute('tabindex', '-1');
      });

      document.body.appendChild(clone);

      this.utilityClone = clone;
    }


    positionUtilityClone() {
      if (!this.utilityOriginal || !this.utilityClone) return;

      const rect = this.utilityOriginal.getBoundingClientRect();

      this.utilityClone.style.left = `${rect.left}px`;
      this.utilityClone.style.top = `${rect.top}px`;
      this.utilityClone.style.width = `${rect.width}px`;
      this.utilityClone.style.height = `${rect.height}px`;

      this.utilityClone.style.display =
        rect.width > 0 && rect.height > 0
          ? ''
          : 'none';
    }


    position() {
      this.positionUtilityClone();
    }


    applyActiveState() {
      const scrolled =
        this.section.classList.contains('scrolled-past-header');

      const active =
        this.homepageOverlay &&
        window.matchMedia('(min-width: 990px)').matches &&
        !scrolled;

      this.section.classList.toggle(
        'peak-inverse-active',
        active
      );

      if (this.utilityClone) {
        this.utilityClone.style.visibility = 'visible';

        this.utilityClone.style.opacity =
          active ? '1' : '0';
      }
    }


    update() {
      this.applyActiveState();

      if (
        this.section.classList.contains('scrolled-past-header')
      ) {
        requestAnimationFrame(() => {
          this.position();
        });
      }
    }
  }


  document.addEventListener('DOMContentLoaded', () => {
    new PeakHeaderAdaptiveIcons();
  });


  } catch(e) { console.error(e); }
})();
})();
